import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";

export const fetchDataBackupList = ({commit}) => {
    
    commit('toggleLoadingState', true)
    axios.get('/dataBackup/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setDataBackupList', res.data)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchDataBackup = ({commit, dispatch}) => {
    
    commit('toggleLoadingState', true)
    setTimeout(() => {
        commit('displayMessageAlert', {message: 'Admin will receive an email in a few minutes.', type: 'Info'})
        commit('toggleLoadingState', false)
    }, 1000);
    axios.get('/dataBackup/save.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        console.log(JSON.stringify(res.data))
        dispatch('fetchDataBackupList')
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}


// WEBPACK FOOTER //
// ./src/store/modules/dataBackup/actions.js